import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import registerUserService from "./RegisterUserService";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import DefaultChip from "../../componentes/chip/DefaultChip";

export default function RegisterUser() {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");
    const loggedUserIdRole = sessionStorage.getItem("role");

    const initialUserState = {
        id: 0,
        idClient: 0,
        username: '',
        blocked: 0,
        role: 0,
        password: '',
        confirmPassword: '',
        status: 1,
        userId: userId,
        warningUser: false,
        warningMessage: '',
        loggedUserId: userId,
    };


    const [user, setUser] = useState(initialUserState);

    const { id, username, password, confirmPassword, role, blocked, status, warningUser, warningMessage, idClient } = user

    const [clearedUser, setClearedUser] = useState(false);
    const [programRoleRows, setUserRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(warningUser);
    const [success, setSuccess] = useState(false);

    const columnsUser = (t) => [
        {
            field: "id",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="id" />;
            },
            template: (props) => {
                return (
                    <>
                        <DefaultChip
                            style="primary"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.id}
                            </Typography>}
                        />
                    </>
                )
            }
        },
        {
            field: "username",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="login" name="user" />;
            },
            flex: 1,
            template: (props) => {
                return (
                    <>
                        {props.username ?
                            <DefaultChip
                                style="primary"
                                label={<Typography
                                    variant="body3"
                                    style={{ whiteSpace: 'normal' }}>{props.username}
                                </Typography>}
                            />
                            : null}
                    </>
                )
            }
        },
        {
            field: "roleDescription",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="role" name="role" />;
            },
            flex: 1,
            template: (props) => {
                return (
                    <>
                        {props.roleDescription ?
                            <DefaultChip
                                style="primary"
                                label={<Typography
                                    variant="body3"
                                    style={{ whiteSpace: 'normal' }}>{props.roleDescription}
                                </Typography>}
                            />
                            : null}
                    </>
                )
            }
        },
        {
            field: "nameClient",
            textAlign: "center",
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="nameClient" name="ronameClientle" />;
            },
            flex: 1,
            template: (props) => {
                return (
                    <>
                        {props.nameClient ?
                            <DefaultChip
                                style="primary"
                                label={<Typography
                                    variant="body3"
                                    style={{ whiteSpace: 'normal' }}>{props.nameClient}
                                </Typography>}
                            />
                            : null}
                    </>
                )
            }
        },
        {
            field: "blockStatus",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="blocked" name="blocked" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.blocked === 1 ? (
                            <IconSwitch name="unLock" />
                        ) : (
                            <IconSwitch name="lock" />
                        )}
                    </>
                );
            },
        },
        {
            field: "status",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.status === 1 ? (
                            <IconSwitch name="active" />
                        ) : (
                            <IconSwitch name="canceled" />
                        )}
                    </>
                );
            },
        },
    ];


    const handleChange = (event) => {
        const { name, value } = event.target;
        setUser({ ...user, [name]: value });
    };

    const handleCloseAlertUser = () => {
        setUser({ ...user, warningUser: false });
    };

    const handleClearUser = () => {
        setClearedUser(!clearedUser);
        setUser(initialUserState);
        setUserRows([]);
    };

    const handleSearchUser = () => {
        let request = { ...user }
        registerUserService
            .get(request)
            .then((response) => {
                console.log("AAAAAA", response.data);
                response.data.forEach((program, index) => {
                    //program.id = index
                    program.idRole = request.idRole
                })
                setUserRows(response.data)
            })
            .catch((e) => {
                setUserRows([]);
            });
    };

    const handleSaveUser = () => {
        let request = { ...user }
        setMessage("");
        setSuccess(false);
        setUser({ ...user, warningUser: false });
        if (handleWarningUser()) {
            registerUserService
                .create(request)
                .then((response) => {
                    if (response.data.id !== 0) {
                        setUser({ ...user, id: response.data.id })
                        setUserRows(response.data)
                        setMessage(t("saveSuccess"));
                        setSuccess(true);
                        handleSearchUser();
                    }
                    else {
                        setMessage(t("userAlreadyRegister"));
                        setUser({ ...user, warningUser: true });
                    }
                })
                .catch((e) => {
                    setMessage(t("saveError"));
                    handleWarningUser();
                });
        }
        else {
            setMessage(t("saveError"));
            //handleWarningUser();
        }
    };

    const handleWarningUser = () => {
        let result = true;
        setUserRows([]);
        if (role === 2 && idClient === 0) {
            setUser({ ...user, warningUser: true });
            result = false;
        }

        if (user.role === 0) {
            setUser({ ...user, warningUser: true });
            result = false;
        }

        if ((user.id === 0) && (user.password === '' && user.confirmPassword === '') || (user.password !== user.confirmPassword)) {
            setUser({ ...user, warningUser: true });
            result = false;
        }

        if (result === true) {
            setUser({ ...user, warningUser: false });
        }

        return result;
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setUser({
            id: rowData.id
            , username: rowData.username
            , userCode: rowData.userCode
            , blocked: rowData.blocked
            , role: rowData.role
            , status: rowData.status
            , idClient: rowData.idClient
        })
    }

    useEffect(() => {
        handleSearchUser();
    }, [user.id]);

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="Cadastrar Usuário"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                success={success}
                                message={message}
                                warning={warningUser}
                                handleCloseAlert={handleCloseAlertUser}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={6}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="user" labelName="username" />
                                        }
                                        name="username"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={username}
                                        length={50}
                                        error={warningUser && username === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"blocked"}
                                        onChange={handleChange}
                                        value={blocked}
                                        label={t("blocked")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("no"), blocked: 0 },
                                            { id: 1, name: t("yes"), blocked: 1 },
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"role"}
                                        onChange={handleChange}
                                        value={role}
                                        label={t("profile")}
                                        defaultSize
                                        useApi
                                        error={warningUser && role === 0}
                                        endpoint='GetProfileAutoComplete'
                                    />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="password" labelName="password" />
                                        }
                                        name="password"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={password}
                                        length={50}
                                        type="password"
                                        error={warningUser && password === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="password" labelName="confirmPassword" />
                                        }
                                        name="confirmPassword"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={confirmPassword}
                                        length={50}
                                        type="password"
                                        error={warningUser && confirmPassword === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                    />
                                </Grid>
                                {role === 2 && <Grid item xs={12} sm={6} md={3}>
                                    <DefaultAutocomplete
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="user" labelName="client" />
                                        }
                                        name="idClient"
                                        onChange={handleChange}
                                        value={idClient}
                                        defaultSize
                                        useApi
                                        endpoint='GetClient'
                                        contextKey={idClient}
                                        error={warningUser && idClient === 0}
                                    />
                                </Grid>}
                            </GridInputRow>
                            {<SearchClearSaveRow
                                onClickClear={handleClearUser}
                                onClickSearch={handleSearchUser}
                                onClickSave={handleSaveUser}
                            />}
                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsUser(t, handleSearchUser)}
                            dataSource={programRoleRows}
                            allowPaging={true}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                        />
                    } />
            ) : null}
        </>
    );
};
